import { Database } from "@/integrations/supabase/types";

// Define Order type locally to avoid circular dependency with useOrders
export type Order = Database['public']['Tables']['allorders']['Row'];

export const ORDER_COLUMNS = `
  created_at,
  customer_phone,
  discount,
  is_posted,
  is_prepaid,
  notified,
  notified_timestamp,
  offer_claimed,
  offer_id,
  offer_items_claimed,
  offer_sent_notified,
  offer_sent_timestamp,
  offer_tier_id,
  order_confirmed_notified,
  order_confirmed_timestamp,
  order_id,
  order_no,
  order_ready_notified,
  order_ready_timestamp,
  order_tags,
  order_type,
  payment_amount,
  payment_type_id,
  posted_by_name,
  posted_time,
  promise_time,
  review_request_sent_notified,
  review_request_sent_timestamp,
  store_id,
  subtotal,
  taken_by,
  updated_at
`;

export const getOrderTypeFromString = (orderType: string | null) => {
  if (!orderType) return {
    orderTypeID: 0,
    orderTypeSubID: 0
  };
  const lowerType = orderType.toLowerCase();
  if (lowerType.includes("carryout") && lowerType.includes("online")) {
    return {
      orderTypeID: 2,
      orderTypeSubID: 7
    };
  } else if (lowerType.includes("delivery") && lowerType.includes("online")) {
    return {
      orderTypeID: 3,
      orderTypeSubID: 7
    };
  } else if (lowerType.includes("delivery")) {
    return {
      orderTypeID: 3,
      orderTypeSubID: 2
    };
  } else if (lowerType.includes("carryout") || lowerType.includes("phone")) {
    return {
      orderTypeID: 2,
      orderTypeSubID: 2
    };
  }
  return {
    orderTypeID: 0,
    orderTypeSubID: 0
  };
};

export const canSendConfirmation = (order: Order) => {
  const {
    orderTypeID,
    orderTypeSubID
  } = getOrderTypeFromString(order.order_type);
  return orderTypeID === 2 && orderTypeSubID === 7 || orderTypeID === 3 && orderTypeSubID === 2 || orderTypeID === 3 && orderTypeSubID === 7 || orderTypeID === 2 && orderTypeSubID === 2;
};

export const canSendReadyNotification = (order: Order) => {
  const {
    orderTypeID,
    orderTypeSubID
  } = getOrderTypeFromString(order.order_type);
  return orderTypeID === 2 && orderTypeSubID === 7 || orderTypeID === 2 && orderTypeSubID === 2;
};

export const formatTime = (timestamp: string | null) => {
  if (!timestamp) return "N/A";
  return new Date(timestamp).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format time from UTC timestamp without any timezone conversion
// Displays the UTC time value directly (e.g., 18:52:00+00 displays as 6:52 PM)
export const formatTimeUTC = (timestamp: string | null) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();

  // Convert to 12-hour format
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12; // Convert 0 to 12 for midnight
  const displayMinutes = minutes.toString().padStart(2, '0');

  return `${displayHours.toString().padStart(2, '0')}:${displayMinutes} ${period}`;
};

export const formatCurrency = (amount: number | null) => {
  if (amount === null) return "N/A";
  return `$${amount.toFixed(2)}`;
};
